module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-900.655a4b4b.svg";